import { useNavigate } from '@tanstack/react-router';
import { RefObject } from 'react';
import { PatientSummaryDto } from '../../../../api/generated/model';
import { TooltipCell } from '../../../../components/table/TooltipCell.tsx';
import { VirtualTablePaddingRow } from '../../../../components/table/VirtualTablePaddingRow.tsx';
import { useCustomVirtualizer } from '../../../../hooks/useCustomVirtualizer.ts';
import { PATIENT_TABLE_CELL_HEIGHT } from '../../../../theme.ts';
import { getComplexCaseStatusName } from '../../../../utils/caseManagement.ts';
import { getTbType } from '../../../../utils/clinicalReport.ts';
import { PatientTable } from './PatientTable.tsx';
import { PatientTablePatientInfosData, PatientTablePatientInfosHeader } from './PatientTablePatientInfos.tsx';

export function PatientsFindingsTable({
  patients,
  parentRef,
}: {
  patients: PatientSummaryDto[];
  parentRef: RefObject<HTMLElement | null>;
}) {
  const navigate = useNavigate();

  const { virtualItems, totalSize, paddingTop, paddingBottom } = useCustomVirtualizer({
    count: patients.length,
    cellHeight: PATIENT_TABLE_CELL_HEIGHT,
    parentRef: parentRef,
  });

  return (
    <PatientTable stickyHeader borderAxis="xBetween" noWrap hoverRow>
      <thead>
        <tr>
          <th style={{ width: 130 }}>Fallnummer</th>
          <PatientTablePatientInfosHeader />
          <th style={{ width: 120 }}>TB</th>
          <th style={{ width: 80 }}>MLB</th>
          <th style={{ width: 80 }}>MKB</th>

          <th style={{ width: 120 }}>EM</th>
          <th>Komplex</th>
        </tr>
      </thead>
      <tbody style={{ height: totalSize }}>
        <VirtualTablePaddingRow height={paddingTop} />

        {virtualItems.map((virtualRow) => {
          const patient = patients[virtualRow.index];
          return (
            <tr
              key={virtualRow.index}
              onClick={() => navigate({ to: '/patients/$patientId', params: { patientId: patient.id } })}>
              <TooltipCell>{patient.caseNumber}</TooltipCell>
              <PatientTablePatientInfosData patient={patient} />
              <td>{patient.clinicalReport && getTbType(patient.clinicalReport.organs)}</td>
              <td>{patient.countLabReports > 0 ? 'Ja' : 'Nein'}</td>
              <td>{patient.clinicalReport ? 'Ja' : 'Nein'}</td>
              <td>{patient.therapy?.supplementFileDetails ? 'Ja' : 'Nein'}</td>
              <TooltipCell>{getComplexCaseStatusName(patient.complexCaseStatus)}</TooltipCell>
            </tr>
          );
        })}
        <VirtualTablePaddingRow height={paddingBottom} />
      </tbody>
    </PatientTable>
  );
}
